import React from 'react';
import './BetaChip.css';

const BetaChip = () => {
  return (
    <span className="beta-chip">
      Beta
    </span>
  );
};

export default BetaChip;

